import(/* webpackMode: "eager" */ "/app/src/app/schedules/page.tsx");
